import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import Auth from '../components/Auth';
import Login from '../components/dashboard/Login';
import ChangeDesign from '../components/ChangeDesign';
import translations from '../translations';

const Designs = () => {
  const { id } = useParams();
  const [login, setLogin] = useState(true);
  const [ownerEmail, setOwnerEmail] = useState(true);
  const [language, setLanguage] = useState(localStorage.getItem('language') || 'en');
  const t = translations[language];
  
  return (
    <div>
      <Helmet>
        <title>{t.changeDesign} | {process.env.REACT_APP_SITE_NAME}</title>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
      <Auth id={id} setLogin={setLogin} setOwnerEmail={setOwnerEmail} />
          {login ? 
            (
              <ChangeDesign />
            ) : ( 
              <div>
                <Login ownerEmail={ownerEmail} setLogin={setLogin} />
              </div>
            )
          }
    </div>
  )
}

export default Designs